"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineStringModel$ = exports.LineStringModel$outboundSchema = exports.LineStringModel$inboundSchema = void 0;
exports.lineStringModelToJSON = lineStringModelToJSON;
exports.lineStringModelFromJSON = lineStringModelFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.LineStringModel$inboundSchema = z.object({
    coordinates: z.array(z.array(z.number())),
    type: z.literal("LineString").default("LineString").optional(),
});
/** @internal */
exports.LineStringModel$outboundSchema = z.object({
    coordinates: z.array(z.array(z.number())),
    type: z.literal("LineString").default("LineString"),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var LineStringModel$;
(function (LineStringModel$) {
    /** @deprecated use `LineStringModel$inboundSchema` instead. */
    LineStringModel$.inboundSchema = exports.LineStringModel$inboundSchema;
    /** @deprecated use `LineStringModel$outboundSchema` instead. */
    LineStringModel$.outboundSchema = exports.LineStringModel$outboundSchema;
})(LineStringModel$ || (exports.LineStringModel$ = LineStringModel$ = {}));
function lineStringModelToJSON(lineStringModel) {
    return JSON.stringify(exports.LineStringModel$outboundSchema.parse(lineStringModel));
}
function lineStringModelFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.LineStringModel$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'LineStringModel' from JSON`);
}
//# sourceMappingURL=linestringmodel.js.map